import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme, Tooltip } from "@mui/material";
import { tokens } from "../../assets/theme";
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const DigitalClock = () => {
    const [time, setTime] = useState(new Date());
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const formatTime = (date) => {
        return date.toLocaleString("sv-SE", {
            hour: "2-digit",
            minute: "2-digit",
        
            hour12: false,
        });
    };

    const formatLongTime = (date) => {
        return date.toLocaleString("sv-SE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
    };

    return (
        <Tooltip title={<Typography style={{ whiteSpace: 'pre-line' }} fontSize="14px">{formatLongTime(time)}</Typography>}>
            <Box
                display="flex"
                pl={2}
                pr={2}
                alignItems="center" mr={2}
                color={colors.primary}
                >
                    <AccessTimeIcon />
                    <Typography variant="h4" component="div" ml={"5px"}>
                        {formatTime(time)}
                    </Typography>
            </Box>
        </Tooltip>
    );
};

export default DigitalClock;
